<div>
    <div class="modal-header">
            <div class="col-md-10">
                <h5 class="modal-title text-start"><strong>Aditivo</strong></h5>
            </div>
            <div class="col-md-2">
                <button type="button" class="btn-close float-end" (click)="fecharPopup()" aria-label="Close"></button>
            </div>

    </div>
    <div class="modal-body">
    <div class="row">
        <ul ngbNav #nav="ngbNav" class="col nav-tabs">
            <li [ngbNavItem]="'aditivo'" id="aditivo" title="Aditivo">
                <button ngbNavLink>Aditivo</button>
                <ng-template ngbNavContent>
                    <div class="row">
                        <div class="bn-form-group col-md-2">
                            <label><b>Data de formalização</b></label>
                            <input type="text" class="form-control" name="dataCelebracaoAditivo"
                                [value]="ajustaCampoDate(aditivo.dataCelebracaoAditivo) | bnMask:'DD/MM/AAAA'" disabled />
                        </div>
                        <div class="bn-form-group col-md-2">
                            <label><b>Data do protocolo</b></label>
                            <input type="text" class="form-control" name="dataEnvio"
                                [value]="ajustaCampoDate(aditivo.dataProtocoloAditivo) | bnMask:'DD/MM/AAAA'" disabled />
                        </div>
                        <div class="bn-form-group col-md-2">
                            <label><b>Saldo devedor refinanciado</b></label>
                            <input type="text" class="form-control" name="saldoDevedorRefinanciado"
                                [(ngModel)]="aditivo.valorSaldoDevedorNaDataDoAditivo" bnMask="MOEDA" disabled />
                        </div>
                        <div class="bn-form-group col-md-2">
                            <label><b>Prazo prorrogado (em meses)</b></label>
                            <input type="text" class="form-control" name="prazoProrrogado"
                                [(ngModel)]="aditivo.quantidadeMesesPrazoAdicional" disabled />
                        </div>
                        <div class="bn-form-group col-md-2">
                            <label><b>Valor da operação</b></label>
                            <input type="text" class="form-control" name="valorOperacao" [(ngModel)]="aditivo.valorOperacao"
                                bnMask="MOEDA" [bnComparacaoA]="aditivo.valorOperacao"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.valorOperacao" disabled />
                        </div>
                    </div>
                    <div class="row">
                        <div class="bn-form-group col-md-2">
                            <label><b>ECG Complementar</b></label>
                            <input type="text" class="form-control" name="ecgComplementar"
                                [(ngModel)]="aditivo.valorEcgComplementar" bnMask="MOEDA" disabled />
                        </div>
                        <div class="bn-form-group col-md-2">
                            <label><b>Ide. Cobrança ECG Compl.</b></label>
                            <input type="text" class="form-control" [value]="aditivo.ideCobrancaEcgComplementar || ''"
                                disabled />
                        </div>

                        <div class="bn-form-group col-md-2">
                            <label><b>Percentual indexador</b></label>
                            <input type="text" class="form-control" name="percentualIndexador"
                                [(ngModel)]="aditivo.percentualIndexador" bnMask="DECIMAL" [casasDecimais]="2"
                                [bnComparacaoA]="aditivo.percentualIndexador"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.percentualIndexador" disabled />
                        </div>
                        <div class="bn-form-group col-md-2">
                            <label><b>Taxa de juros da operação</b></label>
                            <input type="text" class="form-control" name="taxaEfetivaAnual"
                                [(ngModel)]="aditivo.taxaEfetivaAnual" bnMask="DECIMAL" [casasDecimais]="2" [bnComparacaoA]="aditivo.taxaEfetivaAnual"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.taxaEfetivaAnual" disabled />
                        </div>
                        <div class="bn-form-group col-md-2">
                            <label><b>Risco da operação</b></label>
                            <input type="text" class="form-control" [value]="aditivo.riscoOperacao"
                                [bnComparacaoA]="aditivo.riscoOperacao"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.riscoOperacao" disabled />
                        </div>

                        <div class="bn-form-group col-md-6">
                            <label><b>Município do investimento</b></label>
                            <input type="text" class="form-control"
                                value="{{aditivo.detalheCreditoLivre?.nomeMunicipioInvestimento}}"
                                [bnComparacaoA]="aditivo.detalheCreditoLivre?.nomeMunicipioInvestimento"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.nomeMunicipioInvestimento" readonly />
                        </div>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="'cliente'" id="cliente" title="Cliente">
                <button ngbNavLink>Cliente</button>
                <ng-template ngbNavContent>
                    <div class="row">
                        <div class="bn-form-group col-md-4">
                            <label><b>Nome ou razão social</b></label>
                            <input type="text" class="form-control" [value]="aditivo.razaoSocialClienteFinal"
                                [bnComparacaoA]="aditivo.razaoSocialClienteFinal"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.razaoSocialClienteFinal" disabled />
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label><b>CNPJ</b></label>
                            <input type="text" class="form-control" [value]="aditivo.cnpjClienteFinal" bnMask="CNPJ"
                                [bnComparacaoA]="aditivo.cnpjClienteFinal"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.cnpjClienteFinal" disabled />
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label class="block"><b>Natureza jurídica</b></label>
                            <input type="text" class="form-control"
                                value="{{aditivo.detalheCreditoLivre?.nomeNaturezaClienteFinal}}"
                                [bnComparacaoA]="aditivo.detalheCreditoLivre?.nomeNaturezaClienteFinal"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.nomeNaturezaClienteFinal" readonly />
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label class="block"><b>CNAE</b></label>
                            <input type="text" class="form-control" value="{{aditivo.detalhe?.nomeCnaeClienteFinal}}"
                                [bnComparacaoA]="aditivo.detalhe?.nomeCnaeClienteFinal"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.nomeCnaeClienteFinal" readonly />
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label class="block"><b>CNAE Portaria Grande Empresa</b></label>
                            <input type="text" class="form-control"
                                value="{{aditivo.detalheCreditoLivre?.nomeCnaePortariaGrandeEmpresa}}"
                                [bnComparacaoA]="aditivo.detalheCreditoLivre?.nomeCnaePortariaGrandeEmpresa"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.nomeCnaePortariaGrandeEmpresa" readonly />
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label class="block"><b>Receita bruta</b></label>
                            <input type="text" class="form-control" name="receitaBrutaClienteFinal"
                                [(ngModel)]="aditivo.receitaBrutaClienteFinal" [bnMask]="'MOEDA'"
                                [bnComparacaoA]="aditivo.receitaBrutaClienteFinal"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.receitaBrutaClienteFinal" disabled />
                        </div>
                        <div class="bn-form-group col-md-3">
                            <label class="block"><b>Tipo da receita bruta</b></label>
                            <select class="form-select" [value]="aditivo.tipoReceitaBruta"
                                [bnComparacaoA]="aditivo.tipoReceitaBruta"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.tipoReceitaBruta" disabled>
                                <option value=""></option>
                                <option value="E">Efetiva</option>
                                <option value="P">Prevista</option>
                            </select>
                        </div>
                        <div class="bn-form-group col-md-3">
                            <label class="block"><b>Data da receita bruta</b></label>
                            <bn-datepicker name="dataReferenciaReceitaBruta" [(ngModel)]="aditivo.dataReferenciaReceitaBruta"
                                [bnComparacaoA]="aditivo.dataReferenciaReceitaBruta"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.dataReferenciaReceitaBruta" disabled>
                            </bn-datepicker>
                        </div>
                        <div class="bn-form-group col-md-3">
                            <label><b>Município</b></label>
                            <input type="text" class="form-control"
                                value="{{aditivo.enderecoSedeClienteFinal?.nomeMunicipio}}"
                                [bnComparacaoA]="aditivo.enderecoSedeClienteFinal?.nomeMunicipio"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.enderecoSedeClienteFinal?.nomeMunicipio"
                                readonly />
                        </div>
                        <div class="bn-form-group col-md-3">
                            <label><b>Tipo de logradouro</b></label>
                            <input type="text" class="form-control"
                                value="{{aditivo.enderecoSedeClienteFinal?.nomeTipoLogradouro}}"
                                [bnComparacaoA]="aditivo.enderecoSedeClienteFinal?.nomeTipoLogradouro"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.enderecoSedeClienteFinal?.nomeTipoLogradouro"
                                readonly />
                        </div>
                        <div class="bn-form-group col-md-6">
                            <label><b>Logradouro</b></label>
                            <input type="text" class="form-control" name="nomeLogradouro"
                                [(ngModel)]="aditivo.enderecoSedeClienteFinal.nomeLogradouro"
                                [bnComparacaoA]="aditivo.enderecoSedeClienteFinal?.nomeLogradouro"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.enderecoSedeClienteFinal?.nomeLogradouro"
                                disabled />
                        </div>
                        <div class="bn-form-group col-md-2">
                            <label><b>Número</b></label>
                            <input type="text" class="form-control" name="numeroLogradouro"
                                [(ngModel)]="aditivo.enderecoSedeClienteFinal.numeroLogradouro"
                                [bnComparacaoA]="aditivo.enderecoSedeClienteFinal?.numeroLogradouro"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.enderecoSedeClienteFinal?.numeroLogradouro"
                                disabled />
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label><b>Complemento</b></label>
                            <input type="text" class="form-control" name="complemento"
                                [(ngModel)]="aditivo.enderecoSedeClienteFinal.complemento"
                                [bnComparacaoA]="aditivo.enderecoSedeClienteFinal?.complemento"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.enderecoSedeClienteFinal?.complemento"
                                disabled />
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label><b>Bairro</b></label>
                            <input type="text" class="form-control" name="nomeBairro"
                                [(ngModel)]="aditivo.enderecoSedeClienteFinal.nomeBairro"
                                [bnComparacaoA]="aditivo.enderecoSedeClienteFinal?.nomeBairro"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.enderecoSedeClienteFinal?.nomeBairro"
                                disabled />
                        </div>
                        <div class="bn-form-group col-md-2">
                            <label><b>CEP</b></label>
                            <input type="text" class="form-control" name="cep"
                                [(ngModel)]="aditivo.enderecoSedeClienteFinal.cep" bnMask="CEP"
                                [bnComparacaoA]="aditivo.enderecoSedeClienteFinal?.cep"
                                [bnComparacaoB]="aditivo?.historicoAntesAditivo?.enderecoSedeClienteFinal?.cep" disabled />
                        </div>
                        <div class="bn-form-group col-md-6">
                            <label><b>Telefone Beneficiário</b></label>
                            <input type="text" class="form-control" name="telefoneBeneficiario" maxlength="20"
                                [(ngModel)]="aditivo.historicoAntesAditivo.telefoneBeneficiario" disabled />
                        </div>
                        <div class="bn-form-group col-md-3">
                            <label><b>Agência</b></label>
                            <input type="text" class="form-control" name="numeroAgenciaBeneficiario"
                                [(ngModel)]="aditivo.historicoAntesAditivo.numeroAgenciaBeneficiario" disabled />
                        </div>
                        <div class="bn-form-group col-md-9">
                            <label><b>Nome Sócio</b></label>
                            <input type="text" class="form-control" name="nomeSocioBeneficiario"
                                [(ngModel)]="aditivo.historicoAntesAditivo.nomeSocioBeneficiario" disabled />
                        </div>
                        <div class="bn-form-group col-md-3">
                            <label><b>CPF Sócio</b></label>
                            <input type="text" class="form-control" name="cpfSocioBeneficiario"
                                [(ngModel)]="aditivo.historicoAntesAditivo.cpfSocioBeneficiario" bnMask="CPF" disabled />
                        </div>
                        <div class="bn-form-group col-md-2">
                            <label><b>Data Nasc. Sócio</b></label>
                            <input type="text" class="form-control" name="dataNascimentoSocio"
                                [value]="ajustaCampoDate(aditivo.historicoAntesAditivo.dataNascSocioBeneficiario) | bnMask:'DD/MM/AAAA'"
                                disabled />
                        </div>
                        <div class="bn-form-group col-md-2">
                            <label><b>Gênero</b></label>
                            <input type="text" class="form-control" name="genero" [value]="generoSocio" disabled />
                        </div>
                        <div class="bn-form-group col-md-5">
                            <label><b>E-mail Beneficiário</b></label>
                            <input type="text" class="form-control" name="emailBeneficiario"
                                [(ngModel)]="aditivo.historicoAntesAditivo.emailBeneficiario" disabled />
                        </div>
                    </div>
                </ng-template>
            </li>
            <li *ngIf="aditivo.amortizacoes?.length > 0" [ngbNavItem]="'amortizacoes'" id="amortizacoes" title="Amortizações">
                <button ngbNavLink>Amortizações</button>
                <ng-template ngbNavContent>
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">Data da amortização *</th>
                                    <th scope="col" class="coluna-moeda">Valor da amortização *</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let amort of aditivo.amortizacoes; let i = index">
                                    <td>
                                        <span>{{ ajustaCampoDate(amort?.data) | bnMask:'DD/MM/AAAA'}}</span>
                                    </td>
                                    <td class="coluna-moeda">
                                        <span>{{ getValorAmortizacao(amort?.valor) | bnMask:'MOEDA'}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-template>
            </li>
            <li *ngIf="aditivo.historicoAntesAditivo?.amortizacoes?.length > 0" [ngbNavItem]="'amortizacoes-anteriores'"
                id="amortizacoes-anteriores" title="Amortizações Anteriores">
                <button ngbNavLink>Amortizações Anteriores</button>
                <ng-template ngbNavContent>
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">Data da amortização *</th>
                                    <th scope="col" class="coluna-moeda">Valor da amortização *</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let amort of aditivo.historicoAntesAditivo?.amortizacoes; let i = index">
                                    <td>
                                        <span>{{ ajustaCampoDate(amort?.data) | bnMask:'DD/MM/AAAA'}}</span>
                                    </td>
                                    <td class="coluna-moeda">
                                        <span>{{ getValorAmortizacao(amort?.valor) | bnMask:'MOEDA'}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-template>
            </li>
        </ul>

        <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
    </div>
    <div class="modal-footer">
        <div class="row">
            <div class="col-md-12 d-flex justify-content-end">
                <div *ngIf="podeCancelarReverterAditivo()">
                    <button type="button" class="btn btn-primary"
                        bnConfirm tituloConfirm="Confirmação" msgConfirm="Alterações realizadas pelo aditivo à operação serão revertidas. Caso haja alterações posteriores ao aditivo realizadas para a operação, as mesmas serão perdidas. Tem certeza de que deseja cancelar/reverter o aditivo?"
                    (onConfirm)="cancelarAditivo()">Cancelar/reverter aditivo</button>
                </div>
                <button class="btn btn-default" (click)="fecharPopup()">Fechar</button>
            </div>
        </div>
    </div>
</div>
